import { Portrait } from './Icons';


export const common = theme => ({
    ...theme,
    icons: {
        Portrait,
    },
});
